export default __webpack_public_path__ + "static/media/image4.98ad6880.png";